"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateTimeConfig = exports.META_DATA_TIMEZONE = exports.InsightListItemDate = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
var react_intl_1 = require("react-intl");
/**
 * @internal
 */
exports.InsightListItemDate = function (_a) {
    var config = _a.config;
    var relativeDate = config.isToday ? "gs.date.today" : "gs.date.yesterday";
    if (config.isToday || config.isYesterday) {
        return (react_1.default.createElement("span", null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: relativeDate }),
            "\u00A0",
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.date.at" }),
            "\u00A0",
            react_1.default.createElement(react_intl_1.FormattedTime, { value: config.date, format: "hhmm" })));
    }
    else if (config.isCurrentYear) {
        return react_1.default.createElement(react_intl_1.FormattedDate, { value: config.date, format: "shortWithoutYear" });
    }
    return react_1.default.createElement(react_intl_1.FormattedDate, { value: config.date, format: "shortWithYear" });
};
exports.META_DATA_TIMEZONE = "Europe/Prague";
var FORMAT_DATE = "YYYY-MM-DD";
var FORMAT_YEAR = "YYYY";
/**
 * @internal
 */
var sameFormatted = function (firstDate, secondDate, format) {
    return firstDate.format(format) === secondDate.format(format);
};
/**
 * Build date time config for InsightListItemDate component.
 *
 * @param date - string ISO date
 * @param options - optional options object
 * @returns date time config
 *
 * @internal
 */
function getDateTimeConfig(date, options) {
    if (options === void 0) { options = {}; }
    var _a = options.dateTimezone, dateTimezone = _a === void 0 ? exports.META_DATA_TIMEZONE : _a, _b = options.now, now = _b === void 0 ? new Date() : _b;
    var dateWithTimezone = moment_timezone_1.default.tz(date, dateTimezone);
    var dateWithTimezoneInLocal = dateWithTimezone.clone().local();
    var NOW = moment_timezone_1.default(now);
    var TODAY = moment_timezone_1.default(now);
    var YESTERDAY = moment_timezone_1.default(now).subtract(1, "days");
    var isToday = sameFormatted(dateWithTimezoneInLocal, TODAY, FORMAT_DATE);
    var isYesterday = sameFormatted(dateWithTimezoneInLocal, YESTERDAY, FORMAT_DATE);
    var isCurrentYear = sameFormatted(dateWithTimezoneInLocal, NOW, FORMAT_YEAR);
    return {
        date: dateWithTimezone.toDate(),
        isToday: isToday,
        isYesterday: isYesterday,
        isCurrentYear: isCurrentYear,
    };
}
exports.getDateTimeConfig = getDateTimeConfig;
//# sourceMappingURL=InsightListItemDate.js.map